enum iconNames {
    facebook = 'facebook',
    kakao = 'kakao',
    kakaoGift = 'kakaoGift',
    line = 'line',
    naver = 'naver',
    rakuten = 'rakuten'
}

export default iconNames;
